<template>
	<div id="app">
		<router-view />
		<div class="fixed-telphone" v-if="deviceType == 'pc'">
			<img src="images/mobile-white.png" alt="">
			<div class="left-view">预约<br />热线</div>
			<div class="mobile">400-600-5055</div>
		</div>
		<div class="fixed-mobile-telphone" v-if="deviceType == 'mobile'" v-on:click="callCompanyFun('400-600-5055')">
			<img src="images/mobile-white.png" alt="">
			<div class="left-view">预约<br />热线</div>
			<div class="mobile">400-600-5055</div>
		</div>
	</div>
</template>
<script>
	// @ is an alias to /src
	export default {
		name: 'App',
		data() {
			return {
				deviceType: "pc"
			}
		},
		methods: {
			setRemFun() {
				const clientWidth = document.documentElement.clientWidth;
				// let rem = clientWidth / 19.2;
				let rem = clientWidth / 7.5;
				let deviceType = "pc";
				if (clientWidth > 920) {
					rem = clientWidth / 19.2;
				}else{
					deviceType = "mobile";
				}
				this.deviceType = deviceType;
				this.$store.commit({
					type: 'setStoreFun',
					stateName: "deviceType",
					stateValue: deviceType
				});
				document.documentElement.style.fontSize = rem + 'px';
			},callCompanyFun (value){
				window.location.href = "tel:" + value;
			}
		},
		created() {
			const that = this;
			this.setRemFun();
			window.addEventListener('resize', function() {
				that.setRemFun();
			}, false)
		}
	}
</script>
<style scoped="scoped">
	.fixed-telphone{
		padding: 0.2rem 0.4rem;
		box-sizing: border-box;
		background:rgba(255,123,22,0.78);
		border-radius: 0.06rem 0 0  0.06rem;
		position: fixed;
		top: 75%;
		right: 0;
		z-index: 9;
		display: flex;
		align-items: center;
		transform: translateX(3.24rem);
		transition: transform 500ms ease-in-out;
	}
	.fixed-telphone>img{
		width: 0.36rem;
		flex-shrink: 0;
		margin-right: 0.16rem;
	}
	.fixed-telphone>.left-view{
		font-size: 0.18rem;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.1;
		color: #FFFFFF;
	}
	.fixed-telphone>.mobile{
		box-sizing: border-box;
		font-size: 0.42rem;
		font-family:Microsoft YaHei;
		font-weight:400;
		color: #FFFFFF;
		padding-left: 0.2rem;
		
	}
	.fixed-telphone:hover{
		transform: translateX(0);
	}
	.fixed-mobile-telphone{
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 9;
		width: 100%;
		padding: 8px 24px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: center;
		background:rgba(255,123,22,0.82);
	}
	.fixed-mobile-telphone>.left-view{
		font-size: 14px;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.2;
		color: #FFFFFF;
		letter-spacing: 4px;
		margin-right: 4px;
	}
	.fixed-mobile-telphone>img{
		width: 28px;
		flex-shrink: 0;
		margin-right: 8px;
	}
	.fixed-mobile-telphone>.mobile{
		box-sizing: border-box;
		font-size: 28px;
		font-family:Microsoft YaHei;
		font-weight:400;
		color: #FFFFFF;
		line-height: 1.6;
	}
</style>
<style>
	body,
	html {
		margin: 0;
		padding: 0;
		background: #FFFFFF;
		font-family: "Microsoft Yahei", "Hiragino Sans GB", "Helvetica Neue", Helvetica, tahoma, arial, Verdana, sans-serif, "WenQuanYi Micro Hei", "\5B8B\4F53";
		font-size: 12px;
		color: #333;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale
	}
	
</style>
